import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree/dist/core/type/type';

import { ProjectModel } from '@/models/projects';
import { UserModel } from '@/models/users';
import { BaseModel } from '@/stores/shared';

export const FeedbackModel = types.compose(
  BaseModel,
  types.model({
    feedback: types.string,
    mode: types.enumeration('Mode', ['APPLICATION', 'CANDIDATE']),
    topic: types.maybeNull(types.string),
    created: types.string,
    mentor: types.late(() => types.maybe(UserModel)),
    project: types.late(() => types.maybeNull(ProjectModel)),
  }),
);

export type FeedbackModelType = Instance<typeof FeedbackModel> & {};
